<template>
  <div class="options">
    <h5 class="options__title">
      {{ $t('comparator.offers.offer.options') }}
    </h5>
    <ul class="options__ul">
      <li class="options__ul__li" v-for="option in options" :key="option.id">
        <div class="options__ul__li__option">
          <div class="options__ul__li__option__text">
            <span>{{ option.name }}</span>
            <div
              v-if="option.description"
              class="options__ul__li__option__text__gm-price"
              v-html="option.description">
            </div>
          </div>
          <div class="options__ul__li__option__input">
            <el-checkbox
              :disabled="isCheckboxDisabled"
              v-model="option.is_chosen">
              {{ $n(getPrice(option), 'currency') }} {{ $tc('base.priceType', exclTax) }}
            </el-checkbox>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OfferOptions',
  props: {
    options: {
      default: () => [],
      type: Array,
    },
    serviceId: {
      required: true,
      type: String,
    },
    isCheckboxDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      demand: 'demandStore/demand',
    }),
    exclTax() {
      return this.demand.show_price_ht;
    },
  },
  methods: {
    getPrice(option) {
      return this.exclTax ? option.price_ht : option.price_unit;
    },
  },
};
</script>

<style scoped lang="scss">
.options {
  &__ul {
    padding-left: 18px;
    font-size: 16px;
    &__li {
      &:not(:last-child) {
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: 1px solid $--color-grey;
      }
      &__option {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &__text {
          margin: auto 20px auto 0;
          &__gm-price {
            font-size: 13px;
          }
        }
        &__input {
          width: 120px;
          min-width: 120px;
          font-weight: 700;
          border-radius: 4px;
          padding: 6px;
          background-color: $--color-light-grey;
          :deep(.el-checkbox) {
            display: flex;
            flex-direction: row-reverse;
            justify-content: space-between;

            &__label {
              padding-left: 5px;
              padding-right: 10px;
              font-weight: 700;
              color: $--color-font;
            }
          }
        }
      }
    }
  }
}
</style>
